import { OrderSourceName } from './order-api.model';

/**
 * `action` is the one field the orders endpoint serializes by number rather than by
 * name (everything else — side, state, market, source — comes back as a string).
 */
export enum OrderActionEnum {
	Add = 0,
	Modify = 1,
	Cancel = 2
}

export enum ImeMarketType {
	Future = 'Future',
	Option = 'Option',
	Deposit = 'Deposit',
	None = 'None'
}

export enum OrderSideEnum {
	Buy = 'Buy',
	Sell = 'Sell'
}

export enum OrderStateEnum {
	None = 'None',
	Modify = 'Modify',
	Error = 'Error',
	Cancel = 'Cancel',
	Delete = 'Delete',
	Done = 'Done',
	OnBoard = 'OnBoard',
	OnSending = 'OnSending',
	PartiallyExcution = 'PartiallyExcution',
	OnCanceling = 'OnCanceling',
	OnCancelError = 'OnCancelError',
	OnModifyError = 'OnModifyError',
	DeleteByBroker = 'DeleteByBroker',
	Expired = 'Expired',
	PartiallyExcutionAndExpired = 'PartiallyExcutionAndExpired',
	CancelByBrokerForUnBlock = 'CancelByBrokerForUnBlock',
	OnModify = 'OnModify',
	DeleteByNSC = 'DeleteByNSC',
	CancelByBrokerForOrderOnAir = 'CancelByBrokerForOrderOnAir',
	OnModifyBoard = 'OnModifyBoard',
	OrderExecuted = 'OrderExecuted',
	PendingConfirm = 'PendingConfirm',
	Confirmed = 'Confirmed',
	PendingCancelOrder = 'PendingCancelOrder',
	CancelOrderConfirmed = 'CancelOrderConfirmed',
	Reject = 'Reject',
	CancelPendingOrderByUser = 'CancelPendingOrderByUser',
	CancelCancelPendingOrderByUser = 'CancelCancelPendingOrderByUser',
	InOmsQueue = 'InOmsQueue'
}

/**
 * The `/orders` payload exactly as the Kala API returns it. Enum-valued fields come
 * back as their names (`"Buy"`, `"OnBoard"`, `"Deposit"`, `"easyTrader"`), except
 * `action`, which is numeric.
 */
export interface OrderResponseDto {
	orderId: number;
	/** Exchange symbol code, e.g. `"CD1SIB0001"`. */
	symbol: string | null;
	/** Persian display name — frequently null, and passed through as-is (no code/isin substitute). */
	symbolName: string | null;
	/** نام کوتاه نماد — the Persian short name the cards and detail sheet show under the title. */
	symbolShortName: string | null;
	symbolIsin: string;
	market: ImeMarketType;
	side: OrderSideEnum;
	state: OrderStateEnum;
	action: OrderActionEnum;
	/** Which client the order was placed from, e.g. `"easyTrader"`. */
	source: OrderSourceName;
	price: number;
	volume: number;
	executedVolume: number;
	remainingVolume: number;
	entryDate: string;
	/** Set once the order changes state; null while it still sits in its entry state. */
	stateDate: string | null;
	errorCode: string | null;
}

export interface OrdersListData {
	items: OrderResponseDto[];
	totalCount: number;
}
